"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.head = void 0;
exports.head = (values) => values[0];
//# sourceMappingURL=head.js.map